import {
  Grid,
} from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import { DiscountDto } from '@coretava/api/core-service';
import { DiscountStore } from '@gamiphy/loyalty-station-desktop/store/reward/discount';
import Celebration from './Celebration';
import DiscountDetails from './DiscountDetails';

const AutoApply: React.FC<{ discount: DiscountDto }> = ({ discount }) => {
  if (!DiscountStore.appDiscount) return null;

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Celebration convertedPoints={discount.value / (DiscountStore.appDiscount?.value || 1)} />
      </Grid>
      <Grid size={12}>
        <DiscountDetails discount={discount} appDiscount={DiscountStore.appDiscount} />
      </Grid>
    </Grid>

  );
};

export default observer(AutoApply);
